import * as React from 'react'
import { FC, useCallback } from 'react'
import { useSelector } from 'react-redux'

import { ContentBack } from './ContentBack/ContentBack'
import { ContentFront } from './ContentFront/ContentFront'
import {
  flipCard,
  selectOverdueNextActionDates,
} from '@user/store/dashboard/widgets/overdueNextActionDates/slice'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { WidgetWrapper } from '../../Widget/WidgetWrapper'

export const OverdueNextActionDates: FC = () => {
  const dispatch = useAppDispatch()
  const { showFront } = useSelector(selectOverdueNextActionDates)

  const handleFlipCard = useCallback(() => {
    dispatch(flipCard())
  }, [dispatch])

  return (
    <WidgetWrapper
      testIdPrefix="overdue-next-action-dates-widget"
      contentFront={<ContentFront />}
      contentBack={<ContentBack />}
      headerColor="#fdecea"
      title="Records with Overdue Next Action Dates"
      settingsAction={handleFlipCard}
      showFront={showFront}
    />
  )
}

OverdueNextActionDates.displayName = 'OverdueNextActionDates'
